import { render, staticRenderFns } from "./optionalAddition.vue?vue&type=template&id=428c6520&scoped=true"
import script from "./optionalAddition.vue?vue&type=script&lang=ts"
export * from "./optionalAddition.vue?vue&type=script&lang=ts"
import style0 from "./optionalAddition.vue?vue&type=style&index=0&id=428c6520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c6520",
  null
  
)

export default component.exports